/**
 * @requires ./frc.js
 * @requires ./frc.utilities.js
  * @requires ./frc.animations.js
 * @requires ../vendor/handlebars-latest.js
 */

frc.init = {
    "all": function(){
        var self = frc.init;
        self.polyfills();
        frc.utilities.cache.init();
        self.session();
        frc.animations.init();
        self.navBumper();
        //self.backgroundImages();
        self.handlebars();
        self.modules.swiper();
        self.modules.ebites();
        self.header();
        self.messaging();
        self.modules.reservations();
        self.modules.geoSearchCombo();
        self.modules.listingNav();
        self.geolocation();
		self.reservationsModal();
		self.groupDiningModal();
        self.messagingModal();
        self.videoPlayer();
        frc.analytics.init();
    },
    "session": function(){
        frc.data.user.preferredLocation = frc.utilities.cache.get("preferred-location");
        frc.data.user.nearestLocation = frc.utilities.cache.get("nearest-location");
        frc.data.user.nearestOpenTableLocation = frc.utilities.cache.get("nearest-opentable-location");
        frc.data.user.currentlyAtStore = (frc.utilities.cache.get("user-is-at-a-store")||"").toString() == "true";
        frc.data.user.geolocation = frc.utilities.cache.get("geolocation");

        // Make sure we have other circumstantial info based on geolocation
        if(frc.data.user.geolocation && frc.data.user.geolocation.coordinates){
            // Nearest/preferred locations
            if(!frc.data.user.preferredLocation||!frc.data.user.nearestLocation){
                frc.utilities.determineNearestLocations(function(result){
                    if(result.general){
                        // Set preferred and nearest locations
                        // Note: we're assigning the nearest location as the preferred one. In the future, this could conceivably change.
                        frc.data.user.preferredLocation = result.general;
                        frc.utilities.cache.set("preferred-location", result.general, true);

                        frc.data.user.nearestLocation = result.general;
                        frc.utilities.cache.set("nearest-location", result.general, true);

                        var assumedSizeOfStoreFeet = 100; // Distance, in feet, we're assuming a store covers
                        if(result.general.distanceMiles < (assumedSizeOfStoreFeet / 5280)){
                            // User appears to be at a store
                            frc.utilities.cache.set("user-is-at-a-store", "true", true);
                            frc.data.user.currentlyAtStore = true;
                            $(frc).trigger("userdeterminedtobeinstore", result.general);
                        }

                        $(frc).trigger("preferredlocationdetermined", result.general);
                    }
                    if(result.openTable){
                        frc.data.user.nearestOpenTableLocation = result.openTable;
                        frc.utilities.cache.set("nearest-opentable-location", result.openTable, true);
                        $(frc).trigger("nearestopentablelocationdetermined", result.openTable);
                    }
                });
            }

            /*
            // Geolocation description
            if(!frc.data.user.geolocation.description){
                frc.api.core.geocode(frc.data.user.geolocation.coordinates.join(", "), function(results){
                    if(results.success && results.data){
                        var description = results.data.zip;
                        if(!description && (results.data.city&&results.data.state)){
                            description = results.data.city + ", " + results.data.state;
                        }
                        if(description){
                            frc.data.user.geolocation.description = description;
                            frc.utilities.cache.set("geolocation", frc.data.user.geolocation, true);
                            $(frc).trigger("geolocationdescriptiondetermined", description);
                        }
                    }
                });
            }
            */
        }
    },
    "general": function(){
        $(window).on("unload", function(){
            frc.data.userIsLeavingPage = true;
        });
    },
    "polyfills": function(){
          if (!Array.prototype.forEach) {
            Array.prototype.forEach = function forEach(callback, thisArg) {
                if (typeof callback !== 'function') {
                    throw new TypeError(callback + ' is not a function');
                }
                var array = this;
                thisArg = thisArg || this;
                for (var i = 0, l = array.length; i !== l; ++i) {
                    callback.call(thisArg, array[i], i, array);
                }
            };
          }
    },
    /*"backgroundImages": function(){
        jQuery("[data-background-image]").each(function(i, elt){
            var url = $(elt).attr("data-background-image");
            frc.utilities.preloadImage(url, function(e){
                $(elt).css("background-image", "url(" + url + ")").addClass("background-image-loaded");
            });
        });
    },*/
    "geolocation": function(){

        $(frc).on("geolocationcomplete", function(e, results){
            if(results.coords){
                frc.data.user.geolocation = {
                    "coordinates": results.coords
                }
                frc.utilities.cache.set("geolocation", frc.data.user.geolocation, true);

                // Since the user's location has changed, clear out the stuff that hinges on geolocation
                frc.utilities.cache.invalidate("preferred-location");
                frc.utilities.cache.invalidate("nearest-location");
                frc.utilities.cache.invalidate("nearest-opentable-location");
                frc.utilities.cache.invalidate("user-is-at-a-store");
                frc.data.user.preferredLocation = null;
                frc.data.user.nearestLocation = null;
                frc.data.user.nearestOpenTableLocation = null;
                frc.data.user.currentlyAtStore = null;

                frc.init.session(); // Determine nearest locations, etc.
            }
        });

    },
    "handlebars": function(){
        // Register Handlebars helpers
        Handlebars.registerHelper('numberFormat', function (value, options) {
            var dl = options.hash['decimalLength'] || 2;
            var ts = options.hash['thousandsSep'] || ',';
            var ds = options.hash['decimalSep'] || '.';
            var value = parseFloat(value);
            var re = '\\d(?=(\\d{3})+' + (dl > 0 ? '\\D' : '$') + ')';
            var num = value.toFixed(Math.max(0, ~~dl));
            return (ds ? num.replace('.', ds) : num).replace(new RegExp(re, 'g'), '$&' + ts);
        });

        // Example: {{#ifEquals name 'Foo'}}true{{else}}false{{/ifEquals}}
        Handlebars.registerHelper('ifEquals', function(a, b, opts) {
            if (a == b) {
                return opts.fn(this);
            } else {
                return opts.inverse(this);
            }
        });

        // Example: {{math #index "+" 1}}
        Handlebars.registerHelper("math", function(lvalue, operator, rvalue, options) {
            lvalue = parseFloat(lvalue);
            rvalue = parseFloat(rvalue);

            return {
                "+": lvalue + rvalue,
                "-": lvalue - rvalue,
                "*": lvalue * rvalue,
                "/": lvalue / rvalue,
                "%": lvalue % rvalue
            }[operator];
        });

        // Example: {{#ifNotEquals location.nickname location.city }}<div>text</div>{{/ifNotEquals}}
        Handlebars.registerHelper('ifNotEquals', function(arg1, arg2, options) {
            return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
        });
	},

    "reservationsModal": function(){
        $("#reservations-modal").on("modal:before-block", function(){
            var $module = $(this).find(".reservations");

            if(!$module.attr("data-inited")){
                $module.attr("data-inited", "true");
                new frc.modules.reservations($module);
            }
        });

        $("#reservations-modal").on("modal:open", function() {
            frc.animations.reservationsModal(true, $(this));
            $(".jquery-modal.blocker").addClass("open");
        })

        $("#reservations-modal").on("modal:before-close", function() {
            $(".jquery-modal.blocker").removeClass("open");
            frc.animations.reservationsModal(false, $(this));
        });
	},

	"groupDiningModal": function() {
        $("#group-dining-modal").on("modal:before-block", function() {
            var $module = $(this).find("#group-dining-modal");

            if(!$module.attr("data-inited")){
                $module.attr("data-inited", "true");
                new frc.modules.groupDining($module);
            }
        });

        $("#group-dining-modal").on("modal:open", function() {
            frc.animations.groupDiningModal(true, $(this));
            $(".jquery-modal.blocker").addClass("open");
        })

        $("#group-dining-modal").on("modal:before-close", function() {
            $(".jquery-modal.blocker").removeClass("open");
            frc.animations.groupDiningModal(false, $(this));
        });

        // Toggle the hidden on-page WPCF7 contact form
        $("#wpcf-pdr-form").on("click", function() {
            $pdrForm = $('.backup-group-dining-form');

            if ($pdrForm.is(":visible")) {
                $pdrForm.fadeOut(400);
            } else {
                 $pdrForm.fadeIn(600);
            }
        });

        // If WCPF 7 form submission has an error, direct view to bottom of page and
        // open the div which contains the form
        if ($( ".wpcf7-response-output" ).text().indexOf('error') > -1) {
            document.getElementById('group-dining-contact-form').scrollIntoView();
            $('.backup-group-dining-form').fadeIn(300)
        } else if ($('.backup-group-dining-form .screen-reader-response').text().indexOf('sent.') > -1) {
            const successCopy = $('.backup-group-dining-form .screen-reader-response').text();
            // Form has been submitted, display the success message
            document.getElementById('group-dining-contact-form').scrollIntoView();
            $('.backup-group-dining-form').html(successCopy).fadeIn(1000);
        }
	},

    "messagingModal" : function() {
        frc.modules.messagingModal();
	},

    "messaging": function() {
        $('section.messaging').each(function() {
             $(this).Scrollio({
                action: 'toggleClass',
                class: 'in-view',
                trigger: {
                    multiplier: .999
                }
            });
        });
    },
    "modules": {
        "swiper": function(selector, options){
            if((typeof Swiper)!="undefined"){
                new Swiper(selector || ".slideshow .swiper-container", options || {
                    pagination: ".swiper-pagination",
                    paginationClickable: true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    },
                    watchOverflow: true
                });
            }
        },
        "geoSearchCombo": function(){
            jQuery("form[data-module-id=\"geo-search-combo\"]").each(function(i, form){
                new frc.modules.geoSearchCombo($(form));
            });
        },
        "ebites": function(){
            jQuery("[data-module-id=\"ebites\"]").each(function(i, elt){
                new frc.modules.ebites($(elt));
            });
        },
        "reservations": function() {
            jQuery("[data-module-id=\"reservations\"]").each(function(i, module) {
                new frc.modules.reservations($(module));
            });
		},
		"groupDining": function() {
            jQuery("[data-module-id=\"group-dining\"]").each(function(i, module) {
                new frc.modules.groupDining($(module));
            });
        },
        "listingNav": function(){

            if(!$(".listing-state-nav").length){
                return;
            }

            $('#find-location-jump').Selecta({ nativeOnMobile: true, forceRenderBelow: true }).on('selecta-change', function(e, o) {
                var href = '#' + o.$select.val();
                $('.listing-state-nav').addClass('current-override');
                if ($('html').hasClass('history')) {
                    history.pushState(null, null, href);
                }
                else {
                    location.hash = href;
                }

                frc.utilities.anchorScroll(href, $('.listing-state-nav').outerHeight(), function() { $('.listing-state-nav').removeClass('current-override'); });
            });

            if ($('body').hasClass('has-promo')) {
                $('header .nav-container').attr('data-offset', ($('header .nav-wrapper').outerHeight() + $('.promo-bar').outerHeight()));
            }
            else {
                $('header .nav-container').attr('data-offset', $('header .nav-wrapper').outerHeight());
            }

            $(window).on('resize', function() {
                if ($('body').hasClass('has-promo')) {
                    $('header .nav-container').attr('data-offset', ($('header .nav-wrapper').outerHeight() + $('.promo-bar').outerHeight()));
                }
                else {
                    $('header .nav-container').attr('data-offset', $('header .nav-wrapper').outerHeight());
                }
            });

            $('.listing-state-nav').pinUp({
                class: 'pinned',
                container: 'section.block-list .wrapper',
                offset: {
                    element: 'header .nav-container',
                    attribute: 'data-offset'
                },
                watchHandlers: [{
                    object: frc.pages.locations,
                    event: 'viewchanged'
                }]
            });

            $('.listing-block').each(function() {
                $(this).Scrollio({
                    action: 'current',
                    container: 'section.menus.block-list',
                    offset: {
                        element: $('header .nav-container')
                    },
                    onMatch: function(o) {
                        var id = o.attr('id'),
                            href = '#'+ o.attr('id'),
                            $option = $('#find-location-jump option[value="'+ id +'"]');
                        if (!$('.listing-state-nav').hasClass('current-override')) {
                            $('.listing-state-nav a').removeClass('current');
                            $('.listing-state-nav a[href="'+ href +'"]').toggleClass('current');
                            $('#find-location-jump').find('option[value="'+ o.attr('id') +'"]').prop('selected', true);
                            $('#find-location-jump').Selecta('refresh');
                        }
                    },
                    onUnmatch: function(o) {
                        var id = o.attr('id'),
                            href = '#'+ o.attr('id');
                        if (!$('.listing-state-nav').hasClass('current-override')) {
                            $('.listing-state-nav a[href="'+ href +'"]').removeClass('current');
                        }
                    },
                    trigger: {
                        multiplier: .3
                    }
                });
            });

            $(window).on('hashchange', function() {
                frc.utilities.anchorScroll(window.location.hash);
            });

            $('.listing-state-nav a').on('click', function(e) {
                e.preventDefault();
                $('.listing-state-nav').addClass('current-override');
                $('.listing-state-nav a').removeClass('current');
                var href = $(this).attr('href');
                $('.listing-state-nav a[href="'+ href +'"]').addClass('current');
                if ($('html').hasClass('history')) {
                    history.pushState(null, null, href);
                }
                else {
                    location.hash = href;
                }
                frc.utilities.anchorScroll(href, false, function() { $('.listing-state-nav').removeClass('current-override'); });
            });
        }
    },
    "navBumper": function(){
        if($("body").hasClass("nav-bumper")){
            frc.utilities.addNavBumper();
            $(window).on("resize", frc.utilities.addNavBumper);
        }
    },
    "locationsMenu" : function() {
        if ($('header').hasClass('locations-menu-wide') && $('.mobile-nav-switch').css('display') == 'none') {
            var promoHeight = $('.promo-bar').length ? $('.promo-bar').outerHeight() : 0,
                navHeight = $('.nav-container').outerHeight(),
                buttonHeight = $('.locations-menu div.view-all').outerHeight(),
                listHeight = Math.floor($(window).innerHeight() - promoHeight - navHeight - buttonHeight);

            $('header .locations-menu .location-list-container').css({ 'max-height' : listHeight });
        }
        else {
            $('header .locations-menu .location-list-container').removeAttr('style');
        }
    },
    "header": function(){
        /* Triggers mobile nav on/off */
        $('#mobile-nav-state').on('change', function() {
            if ($(this).is(':checked')) {
                $('.mobile-nav-switch').addClass('open');
                var navHeight = $(window).height() - $('.nav-container').outerHeight();
                $('header .nav-container #mobile-nav-state:checked + nav').css('max-height', navHeight);
            }
            else {
                $('.mobile-nav-switch').removeClass('open');
                $('header .nav-container nav').css('max-height', 0);
            }
        });

        frc.init.locationsMenu();
        $(window).on('resize', function() {
            frc.init.locationsMenu();
        });

        /* Triggers locations nav on/off */
        $('nav .sections .more > a').each(function() {
            $(this).click(function(e) {
                $this = $(this);
                e.preventDefault();
                $(this).parent().toggleClass('open');
                $(this).parent().toggleClass('active');

                $(this).parent().find('.locations-menu').one('transitionend oTransitionEnd MSTransitionEnd', function() {
                    if ($this.parent().hasClass('open')) {
                        $(window).trigger('locations-nav-open');
                    }
                });
            });
        });

        $(window).on('locations-nav-open', function() {
            $(window).on('click', function(e) {
                if (!frc.utilities.maury($(e.target), $('.sections li.more'))) {
                    $('.sections li.more').removeClass('open').removeClass('active');
                }
            });
        });

        /* Toggles white background on sticky top nav */
        $('header .nav-container').Scrollio({
            action: 'toggleClass',
            class: 'sticky',
            fixed: true,
            trigger: {
                value: $('header').innerHeight(),
                multiplier: .4
            }
        });

        /* Parallax for header background image */
        $('header.north-header').Scrollio({
            action: 'parallax',
            trigger: {
                value: 0
            },
            parallax: {
                property: 'background-position-y',
                end: 80
            }
        });

        $(window).on('load', function() {
            frc.utilities.anchorScroll();
        });
    },
    "videoPlayer": function() {
       $(window).on('ytAPI', function() {
         $('main iframe').each(function() {
            var contentVideo = new frcVideo({source: $(this)});
         });
       });
    }
}
